import type { CreateKnowledgeBaseInput } from "../entities/knowledge-base"
import type { KnowledgeBaseRepository } from "../repositories/knowledge-base-repository"

export const makeUpdateKnowledgeBase = (repo: KnowledgeBaseRepository) =>
  (id: string, input: CreateKnowledgeBaseInput) =>
    repo.update(id, input)
